export function UpdateLetterBatch(fields) {
  return {
    type: 'UPDATE_LETTER_BATCH',
    newData: fields,
  };
}
